import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import {
  BulkAllocationState,
  BulkAllocationUploadRequest,
  BulkAllocationUploadResponse,
} from 'redux/types/Allocation.types';

export const bulkAllocationInitialState: BulkAllocationState = {
  loading: false,
  error: null,
  success: false,
  data: null,
};

const BulkAllocationSlice = createSlice({
  name: 'bulkAllocation',
  initialState: bulkAllocationInitialState,
  reducers: {
    bulkAllocationUploadReq: (
      state,
      _action: PayloadAction<BulkAllocationUploadRequest>
    ) => {
      state.loading = true;
      state.error = null;
      state.success = false;
    },
    bulkAllocationUploadSuccess: (
      state,
      action: PayloadAction<BulkAllocationUploadResponse>
    ) => {
      state.loading = false;
      state.success = true;
      state.data = action.payload;
    },
    bulkAllocationUploadFailure: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = action.payload;
      state.success = false;
    },
    resetBulkAllocationState: (state) => {
      state.loading = false;
      state.error = null;
      state.success = false;
      state.data = null;
    },
  },
});

export const {
  bulkAllocationUploadReq,
  bulkAllocationUploadSuccess,
  bulkAllocationUploadFailure,
  resetBulkAllocationState,
} = BulkAllocationSlice.actions;

export default BulkAllocationSlice.reducer;
